import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PeekSourceClass;
function PeekSource() {
  if (PeekSourceClass === VOID) {
    class $ {
      constructor(upstream) {
        this.w4j_1 = upstream;
        this.x4j_1 = this.w4j_1.i3y();
        this.y4j_1 = this.x4j_1.x4h_1;
        var tmp = this;
        var tmp0_safe_receiver = this.x4j_1.x4h_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f4i_1;
        tmp.z4j_1 = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        this.a4k_1 = false;
        this.b4k_1 = 0n;
      }
      y4i(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!!this.a4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().o2(toString(message_0));
        }
        // Inline function 'kotlin.check' call
        if (!(this.y4j_1 == null || (this.y4j_1 === this.x4j_1.x4h_1 && this.z4j_1 === ensureNotNull(this.x4j_1.x4h_1).f4i_1))) {
          var message_1 = 'Peek source is invalid because upstream source was used';
          throw IllegalStateException().o(toString(message_1));
        }
        if (byteCount === 0n)
          return 0n;
        // Inline function 'kotlin.Long.plus' call
        var this_0 = this.b4k_1;
        var tmp$ret$7 = add(this_0, fromInt(1));
        if (!this.w4j_1.p3y(tmp$ret$7))
          return -1n;
        if (this.y4j_1 == null && !(this.x4j_1.x4h_1 == null)) {
          this.y4j_1 = this.x4j_1.x4h_1;
          this.z4j_1 = ensureNotNull(this.x4j_1.x4h_1).f4i_1;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = subtract(this.x4j_1.q2(), this.b4k_1);
        var toCopy = byteCount <= b ? byteCount : b;
        this.x4j_1.q4i(sink, this.b4k_1, add(this.b4k_1, toCopy));
        this.b4k_1 = add(this.b4k_1, toCopy);
        return toCopy;
      }
      m6() {
        this.a4k_1 = true;
      }
    }
    initMetadataForClass($, 'PeekSource', VOID, VOID, [AutoCloseable()]);
    PeekSourceClass = $;
  }
  return PeekSourceClass;
}
//region block: exports
export {
  PeekSource as PeekSource3frbthc9yehpr,
};
//endregion

//# sourceMappingURL=PeekSource.mjs.map
